export const STANDALONE_ROUTES = ["/profile", "/settings", "/company"];
